/**
 * @generated SignedSource<<1705f899dc3f71cde49a761d60aefefb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BasisEnum = "CASH" | "NORMALIZED" | "%future added value";
export type PnlLineDrillEnum = "AFTER_DISTRIBUTIONS" | "COGS" | "DEBT_OUTSTANDING" | "DISTRIBUTIONS" | "EBITDA" | "GROSS_PROFIT" | "G_AND_A" | "INTEREST_AND_FEES" | "LOAN_PRINCIPAL_REPAID" | "LOAN_PROCEEDS" | "OTHER_OPEX" | "REVENUE" | "R_AND_D" | "S_AND_M" | "TAXES" | "TAX_PAID" | "UNCATEGORIZED" | "%future added value";
export type pnlMonthPage_Query$variables = {
  basis?: BasisEnum | null | undefined;
  month: string;
  perspectiveId?: string | null | undefined;
  threshold?: number | null | undefined;
};
export type pnlMonthPage_Query$data = {
  readonly allStakeholders: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly bankAccounts: ReadonlyArray<{
    readonly id: string;
    readonly last4: string | null | undefined;
    readonly name: string;
    readonly nickname: string;
  }>;
  readonly categories: ReadonlyArray<{
    readonly color: string;
    readonly id: string;
    readonly name: string;
    readonly parent: {
      readonly id: string;
    } | null | undefined;
  }>;
  readonly perspective: {
    readonly id: string;
  };
  readonly pnlMonth: {
    readonly month: string;
    readonly months: ReadonlyArray<string>;
    readonly revenue: number;
    readonly rows: ReadonlyArray<{
      readonly amount: number | null | undefined;
      readonly category: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly color: string | null | undefined;
      readonly counterpartyCount: number | null | undefined;
      readonly depth: number;
      readonly kind: string;
      readonly label: string;
      readonly nodeId: string;
      readonly parentNodeId: string | null | undefined;
      readonly pnlLine: PnlLineDrillEnum | null | undefined;
      readonly ratio: number | null | undefined;
      readonly sliceAmountCents: number | null | undefined;
      readonly sliceType: string | null | undefined;
      readonly sliceWeight: number | null | undefined;
      readonly stakeholder: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly strong: boolean;
    }>;
    readonly threshold: number;
  };
};
export type pnlMonthPage_Query = {
  response: pnlMonthPage_Query$data;
  variables: pnlMonthPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "basis"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "month"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "perspectiveId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "threshold"
},
v4 = {
  "kind": "Variable",
  "name": "perspectiveId",
  "variableName": "perspectiveId"
},
v5 = [
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = [
  (v6/*: any*/)
],
v8 = {
  "alias": null,
  "args": (v5/*: any*/),
  "concreteType": "Perspective",
  "kind": "LinkedField",
  "name": "perspective",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": (v5/*: any*/),
  "concreteType": "Category",
  "kind": "LinkedField",
  "name": "categories",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Category",
      "kind": "LinkedField",
      "name": "parent",
      "plural": false,
      "selections": (v7/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "BankAccount",
  "kind": "LinkedField",
  "name": "bankAccounts",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nickname",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "last4",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = [
  (v6/*: any*/),
  (v9/*: any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "Stakeholder",
  "kind": "LinkedField",
  "name": "allStakeholders",
  "plural": true,
  "selections": (v13/*: any*/),
  "storageKey": null
},
v15 = [
  {
    "kind": "Variable",
    "name": "basis",
    "variableName": "basis"
  },
  {
    "kind": "Variable",
    "name": "month",
    "variableName": "month"
  },
  (v4/*: any*/),
  {
    "kind": "Variable",
    "name": "threshold",
    "variableName": "threshold"
  }
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "months",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "threshold",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "revenue",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentNodeId",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "depth",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "strong",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ratio",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pnlLine",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sliceType",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sliceAmountCents",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sliceWeight",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "counterpartyCount",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "Category",
  "kind": "LinkedField",
  "name": "category",
  "plural": false,
  "selections": (v13/*: any*/),
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "Stakeholder",
  "kind": "LinkedField",
  "name": "stakeholder",
  "plural": false,
  "selections": (v13/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "pnlMonthPage_Query",
    "selections": [
      (v8/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v14/*: any*/),
      {
        "alias": null,
        "args": (v15/*: any*/),
        "concreteType": "PnlMonth",
        "kind": "LinkedField",
        "name": "pnlMonth",
        "plural": false,
        "selections": [
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PnlMonthNode",
            "kind": "LinkedField",
            "name": "rows",
            "plural": true,
            "selections": [
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v10/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "pnlMonthPage_Query",
    "selections": [
      (v8/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v14/*: any*/),
      {
        "alias": null,
        "args": (v15/*: any*/),
        "concreteType": "PnlMonth",
        "kind": "LinkedField",
        "name": "pnlMonth",
        "plural": false,
        "selections": [
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PnlMonthNode",
            "kind": "LinkedField",
            "name": "rows",
            "plural": true,
            "selections": [
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v10/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c940e7cd0c54723130041702cd83df63",
    "id": null,
    "metadata": {},
    "name": "pnlMonthPage_Query",
    "operationKind": "query",
    "text": "query pnlMonthPage_Query(\n  $month: String!\n  $perspectiveId: ID\n  $threshold: Int\n  $basis: BasisEnum\n) {\n  perspective(perspectiveId: $perspectiveId) {\n    id\n  }\n  categories(perspectiveId: $perspectiveId) {\n    id\n    name\n    color\n    parent {\n      id\n    }\n  }\n  bankAccounts {\n    id\n    name\n    nickname\n    last4\n  }\n  allStakeholders {\n    id\n    name\n  }\n  pnlMonth(month: $month, perspectiveId: $perspectiveId, threshold: $threshold, basis: $basis) {\n    month\n    months\n    threshold\n    revenue\n    rows {\n      nodeId\n      parentNodeId\n      kind\n      label\n      depth\n      strong\n      amount\n      ratio\n      pnlLine\n      color\n      sliceType\n      sliceAmountCents\n      sliceWeight\n      counterpartyCount\n      category {\n        id\n        name\n      }\n      stakeholder {\n        id\n        name\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "aaa667075f6aa4a232f107e0798eafac";

export default node;
